import { ToBillArguments, ToBillEvent } from '../../../models/Factura';
import { FiscalpopProfile } from '../../../models/Profile';

/**
 * Fills the CFDI fields the API requires but the recovered bill events might be missing.
 */
export function normalizeBillEventsForStamping(billEvents: ToBillEvent[], billArgument: ToBillArguments<ToBillEvent>, fpProfile: FiscalpopProfile) {
    billEvents.forEach(e => {
        if (!!e.CFDI && !e.CFDI.lugarExpedicion) {
            e.CFDI.lugarExpedicion = fpProfile.lugarExpedicion;
        }
        if (!!e.NotaCreditoCFDI && !e.NotaCreditoCFDI.lugarExpedicion) {
            e.NotaCreditoCFDI.lugarExpedicion = fpProfile.lugarExpedicion;
        }
        if (!!e.NotaCreditoCFDI && !e.NotaCreditoCFDI.tipoDeComprobante) {
            e.NotaCreditoCFDI.tipoDeComprobante = 'E';
        }
        // Having CFDI and Nota Credito store fechas breaks billing
        // >> even if they are set, they should be removed
        if (!!e.CFDI && !e.CFDI.fecha) {
            e.CFDI.fecha = new Date().toJSON()
        }
        if (!!e.CFDI && !e.CFDI.tipoDeComprobante) {
            e.CFDI.tipoDeComprobante = 'I';
        }
        if (!!e.NotaCreditoCFDI && !e.NotaCreditoCFDI.fecha) {
            e.NotaCreditoCFDI.fecha = new Date().toJSON();
        }
        if (!!e.NotaCreditoCFDI && !e.NotaCreditoCFDI.cfdiRelacionados.uuids.length && billArgument.uuid) {
            e.NotaCreditoCFDI.cfdiRelacionados.uuids = [billArgument.uuid];
        } else if (!!e.NotaCreditoCFDI && !!e.NotaCreditoCFDI.cfdiRelacionados && billArgument.uuid) {
            e.NotaCreditoCFDI.cfdiRelacionados = {
                tipoRelacion: '07',
                uuids: [billArgument.uuid]
            }
        }
    })
    return billEvents;
}
